module.exports = __webpack_public_path__ + "static/media/class_job_014.a8634af9.svg";